"use strict";

exports.__esModule = true;
exports.HistoricalPartCountScreen = HistoricalPartCountScreen;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Device = require("../../Device");
var _Core = require("../../Core");
var _App = require("../../App");
var _Report = require("../../Report");
var _HistoricalPartCountGridConfig = require("../HistoricalPartCountGrid/HistoricalPartCountGridConfig");
var _HistoricalPartCountToolbar = require("../HistoricalPartCountToolbar/HistoricalPartCountToolbar");
var _Auth = require("../../Auth");
var _checkAccess = require("../../Auth/checkAccess");
var _constants = require("../../Auth/constants");
var _Env = require("../../Env");
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _HistoricalPartCountPopups = require("../HistoricalPartCountPopups");
var _featureFlags = require("../../../featureFlags");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "HistoricalPartCountScreen__Wrapper",
  componentId: "sc-4t6yjg-0"
})(["display:flex;flex-direction:column;height:100vh;"]);
var GridWrapper = _styledComponents["default"].div.withConfig({
  displayName: "HistoricalPartCountScreen__GridWrapper",
  componentId: "sc-4t6yjg-1"
})(["flex:1 1 auto;min-width:0;min-height:0;position:relative;overflow:hidden;"]);
function HistoricalPartCountScreen() {
  var _env$featureFlags;
  var _useContext = (0, _react.useContext)(_Core.TranslatorContext),
    translate = _useContext.translate;
  var devices = (0, _react.useContext)(_Device.DeviceListContext);
  var env = (0, _react.useContext)(_Env.EnvContext);
  var canEditShift = !!(env != null && (_env$featureFlags = env.featureFlags) != null && _env$featureFlags.includes(_featureFlags.ENABLE_HISTORICAL_PART_COUNT_SHIFT_EDIT));
  var isUserPermittedToEdit = (0, _checkAccess.checkAuth)(_constants.PERMISSIONS["EDIT_HISTORICAL_PART_COUNT"].permissions);
  var _useState = (0, _react.useState)({
      editOpen: false,
      deleteOpen: false,
      editShiftOpen: false,
      values: {}
    }),
    action = _useState[0],
    setAction = _useState[1];
  var HistoricalPartCountActions = function HistoricalPartCountActions(props) {
    var values = props.values,
      reload = props.reload;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.Button, {
      minimal: true,
      icon: _icons.IconNames.EDIT,
      "data-testid": "HistoricalPartCountActions.button.edit." + values.id,
      intent: _core.Intent.PRIMARY,
      onClick: function onClick() {
        setAction({
          editOpen: true,
          values: values,
          reload: reload
        });
      }
    }), /*#__PURE__*/_react["default"].createElement(_core.Button, {
      minimal: true,
      icon: _icons.IconNames.TRASH,
      "data-testid": "HistoricalPartCountActions.button.delete." + values.id,
      intent: _core.Intent.DANGER,
      onClick: function onClick() {
        setAction({
          deleteOpen: true,
          values: values,
          reload: reload
        });
      }
    }));
  };
  var HistoricalPartCountShiftActions = function HistoricalPartCountShiftActions(props) {
    var values = props.values,
      reload = props.reload,
      dateRange = props.dateRange;
    return /*#__PURE__*/_react["default"].createElement(_Auth.HasAccess, {
      featureFlag: _featureFlags.ENABLE_HISTORICAL_PART_COUNT_SHIFT_EDIT
    }, /*#__PURE__*/_react["default"].createElement(_core.Button, {
      minimal: true,
      icon: _icons.IconNames.EDIT,
      "data-testid": "HistoricalPartCountShiftActions.button.edit." + values.device + "." + values.partKind + "." + values.partProcess + "." + values.shift + "." + values.workday,
      intent: _core.Intent.PRIMARY,
      onClick: function onClick() {
        setAction({
          editShiftOpen: true,
          values: values,
          dateRange: dateRange,
          reload: reload
        });
      }
    }));
  };
  var config = (0, _HistoricalPartCountGridConfig.getHistoricalPartCountConfig)(isUserPermittedToEdit ? HistoricalPartCountActions : undefined, isUserPermittedToEdit && canEditShift ? HistoricalPartCountShiftActions : undefined);
  return /*#__PURE__*/_react["default"].createElement(_Core.Screen, {
    title: translate("HistoricalPartCountScreen.title", "Historical Part Count")
  }, /*#__PURE__*/_react["default"].createElement(Wrapper, null, /*#__PURE__*/_react["default"].createElement(_App.AppNavbar, {
    title: translate("HistoricalPartCountScreen.navbar.title", "Historical Part Count")
  }), /*#__PURE__*/_react["default"].createElement(_Core.ErrorBoundary, null, /*#__PURE__*/_react["default"].createElement(_Report.StandardReportDataProvider, {
    timeRangeKind: "multiDay"
  }, /*#__PURE__*/_react["default"].createElement(_HistoricalPartCountToolbar.HistoricalPartCountToolbar, {
    devices: devices
  }), /*#__PURE__*/_react["default"].createElement(GridWrapper, null, /*#__PURE__*/_react["default"].createElement(_Core.ComponentSize, null, function (_ref) {
    var width = _ref.width,
      height = _ref.height;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Report.Report, {
      config: config,
      width: width,
      height: height
    }), /*#__PURE__*/_react["default"].createElement(_HistoricalPartCountPopups.HistoricalPartCountPopup, {
      action: action,
      setAction: setAction
    }), /*#__PURE__*/_react["default"].createElement(_HistoricalPartCountPopups.HistoricalPartCountShiftPopup, {
      action: action,
      setAction: setAction
    }));
  }))))));
}